/* src/components/Solar/IncentivesDropdown.svelte generated by Svelte v3.48.0 */
import {
	SvelteComponent,
	add_render_callback,
	append_hydration,
	attr,
	children,
	claim_component,
	claim_element,
	claim_space,
	claim_text,
	create_component,
	destroy_component,
	destroy_each,
	detach,
	element,
	init,
	insert_hydration,
	listen,
	mount_component,
	safe_not_equal,
	select_option,
	select_value,
	set_data,
	space,
	text,
	transition_in,
	transition_out
} from "svelte/internal";

import Incentives from '../Solar/Incentives.svelte';

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[9] = list[i];
	return child_ctx;
}

// (25:6) {#each states as state}
function create_each_block(ctx) {
	let option;
	let t_value = /*state*/ ctx[9].name + "";
	let t;
	let option_value_value;
	let option_selected_value;

	return {
		c() {
			option = element("option");
			t = text(t_value);
			this.h();
		},
		l(nodes) {
			option = claim_element(nodes, "OPTION", {});
			var option_nodes = children(option);
			t = claim_text(option_nodes, t_value);
			option_nodes.forEach(detach);
			this.h();
		},
		h() {
			option.__value = option_value_value = /*state*/ ctx[9].id;
			option.value = option.__value;
			option.selected = option_selected_value = /*selectedState*/ ctx[1] === /*state*/ ctx[9].id;
		},
		m(target, anchor) {
			insert_hydration(target, option, anchor);
			append_hydration(option, t);
		},
		p(ctx, dirty) {
			if (dirty & /*states*/ 1 && t_value !== (t_value = /*state*/ ctx[9].name + "")) set_data(t, t_value);

			if (dirty & /*states*/ 1 && option_value_value !== (option_value_value = /*state*/ ctx[9].id)) {
				option.__value = option_value_value;
				option.value = option.__value;
			}

			if (dirty & /*selectedState, states*/ 3 && option_selected_value !== (option_selected_value = /*selectedState*/ ctx[1] === /*state*/ ctx[9].id)) {
				option.selected = option_selected_value;
			}
		},
		d(detaching) {
			if (detaching) detach(option);
		}
	};
}

function create_fragment(ctx) {
	let section;
	let div;
	let p;
	let t0;
	let t1;
	let select;
	let t2;
	let incentives_1;
	let current;
	let mounted;
	let dispose;
	let each_value = /*states*/ ctx[0];
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	incentives_1 = new Incentives({
			props: {
				name: /*name*/ ctx[2],
				stateSlug: /*stateSlug*/ ctx[3],
				incentives: /*incentivesFiltered*/ ctx[4],
				customHeader: "Solar incentives, tax credit, and rebates by state."
			}
		});

	return {
		c() {
			section = element("section");
			div = element("div");
			p = element("p");
			t0 = text("Select a state:");
			t1 = space();
			select = element("select");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t2 = space();
			create_component(incentives_1.$$.fragment);
			this.h();
		},
		l(nodes) {
			section = claim_element(nodes, "SECTION", { class: true });
			var section_nodes = children(section);
			div = claim_element(section_nodes, "DIV", { class: true });
			var div_nodes = children(div);
			p = claim_element(div_nodes, "P", { class: true });
			var p_nodes = children(p);
			t0 = claim_text(p_nodes, "Select a state:");
			p_nodes.forEach(detach);
			t1 = claim_space(div_nodes);
			select = claim_element(div_nodes, "SELECT", { class: true });
			var select_nodes = children(select);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].l(select_nodes);
			}

			select_nodes.forEach(detach);
			div_nodes.forEach(detach);
			t2 = claim_space(section_nodes);
			claim_component(incentives_1.$$.fragment, section_nodes);
			section_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(p, "class", "svelte-ncvedx");
			attr(select, "class", "svelte-ncvedx");
			if (/*selectedState*/ ctx[1] === void 0) add_render_callback(() => /*select_change_handler*/ ctx[8].call(select));
			attr(div, "class", "solarIncentives-filter__dropdown svelte-ncvedx");
			attr(section, "class", "solarIncentives-filter");
		},
		m(target, anchor) {
			insert_hydration(target, section, anchor);
			append_hydration(section, div);
			append_hydration(div, p);
			append_hydration(p, t0);
			append_hydration(div, t1);
			append_hydration(div, select);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(select, null);
			}

			select_option(select, /*selectedState*/ ctx[1]);
			append_hydration(section, t2);
			mount_component(incentives_1, section, null);
			current = true;

			if (!mounted) {
				dispose = listen(select, "change", /*select_change_handler*/ ctx[8]);
				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*states, selectedState*/ 3) {
				each_value = /*states*/ ctx[0];
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(select, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}

			if (dirty & /*selectedState, states*/ 3) {
				select_option(select, /*selectedState*/ ctx[1]);
			}

			const incentives_1_changes = {};
			if (dirty & /*name*/ 4) incentives_1_changes.name = /*name*/ ctx[2];
			if (dirty & /*stateSlug*/ 8) incentives_1_changes.stateSlug = /*stateSlug*/ ctx[3];
			if (dirty & /*incentivesFiltered*/ 16) incentives_1_changes.incentives = /*incentivesFiltered*/ ctx[4];
			incentives_1.$set(incentives_1_changes);
		},
		i(local) {
			if (current) return;
			transition_in(incentives_1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(incentives_1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(section);
			destroy_each(each_blocks, detaching);
			destroy_component(incentives_1);
			mounted = false;
			dispose();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { states, incentives, stateInfo } = $$props;
	let selectedState = 10, name, stateSlug, incentivesFiltered, stateInfoFiltered;

	function select_change_handler() {
		selectedState = select_value(this);
		$$invalidate(1, selectedState);
		$$invalidate(0, states);
	}

	$$self.$$set = $$props => {
		if ('states' in $$props) $$invalidate(0, states = $$props.states);
		if ('incentives' in $$props) $$invalidate(5, incentives = $$props.incentives);
		if ('stateInfo' in $$props) $$invalidate(6, stateInfo = $$props.stateInfo);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*incentives, selectedState, stateInfo, stateInfoFiltered*/ 226) {
			$: {
				$$invalidate(4, incentivesFiltered = incentives.filter(item => item.state_id === selectedState));
				$$invalidate(7, stateInfoFiltered = stateInfo.filter(item => item.id === selectedState));
				$$invalidate(2, name = stateInfoFiltered[0].name.replace(/ /g, '\xa0'));
				$$invalidate(3, stateSlug = stateInfoFiltered[0].short_name);
			}
		}
	};

	return [
		states,
		selectedState,
		name,
		stateSlug,
		incentivesFiltered,
		incentives,
		stateInfo,
		stateInfoFiltered,
		select_change_handler
	];
}

class IncentivesDropdown extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { states: 0, incentives: 5, stateInfo: 6 });
	}
}

export default IncentivesDropdown;